import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SearchQueryService } from '@app/core/services/search/resource-search/search-query.service';
import { BiosampleLibraryPrepSearchColumnFields } from '../gridOptions/biosample-library-prep-search-grid-options-formatter';
import { ISearchDataSourceOptions, SearchDataSource } from './search.datasource';
import { ISearchFilter } from '@app/core/services/search/resource-search/search-query-types.service';

export class BiosampleLibraryPrepSearchDataSource extends SearchDataSource {
    constructor(
        searchQueryService: SearchQueryService,
        resourceDictionaryService: SearchResourceDictionaryService,
        dataSourceOptions: ISearchDataSourceOptions
    ) {
        const biosampleLibraryPrepResourceDictionary = resourceDictionaryService.getResourceConfigByType(SearchResourceType.BiosampleLibraryPrep);
        super(searchQueryService, biosampleLibraryPrepResourceDictionary, dataSourceOptions);
        
        const filterMethods: {[field: string]: (field: string, filterObj: any) => ISearchFilter} = {
            DefaultProjectName: (field, filterObj) => {
                return {
                    facets: ['BioSampleCompact.DefaultProject.Id'],
                    currentChoice: {
                        value: filterObj.value,
                        label: null,
                    }
                }
            }
        };

        this.filterMethods = filterMethods as any;
    
    }

    get rawTextFilterColumnName(): string {
        return BiosampleLibraryPrepSearchColumnFields.BioSampleName;
    }
}

